import $ from 'jquery';

const bootstrap = require('bootstrap');

export class ConfirmModal {

    modalComponent;
    modal;

    confirmCallback;
    cancelCallback;

    constructor() {
        this.modalComponent = $('#confirm-modal');
        if (this.modalComponent.length === 0) {
            return;
        }

        this.modal = new bootstrap.Modal(this.modalComponent, {});

        this.modalComponent.find('.btn-cancel').click(() => {
            this.cancel();
        });

        this.modalComponent.find('.btn-confirm').click(() => {
            this.confirm();
        });
    }

    show(question, title, confirmCallback, cancelCallback) {
        this.modalComponent.find('div.modal-body').html(question);
        this.modalComponent.find('h3.modal-title').html(title);

        this.modal.show();
        this.confirmCallback = confirmCallback;
        this.cancelCallback = cancelCallback;
    }

    confirm() {
        this.modal.hide();
        if (this.confirmCallback) {
            this.confirmCallback();
        }
    }

    cancel() {
        this.modal.hide();
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    }

}
